import { Plus, Trash2 } from "lucide-react";
import { PersonInput } from "@/components/PersonInput";
import { t } from "@/i18n";

export const ArtistList = ({ items, onChange, max = 5, testId, placeholder = "Nombre artístico", addLabel = "Agregar artista" }) => {
  const upd = (i, name) => onChange(items.map((n, j) => (j === i ? name : n)));
  return (
    <div className="space-y-2" data-testid={testId}>
      {items.map((name, i) => (
        <div key={i} className="flex gap-2 items-center">
          <PersonInput value={name} onChange={(v) => upd(i, v)} kind="artist" placeholder={t(placeholder)} testId={`${testId}-${i}`} className="flex-1" />
          <button type="button" onClick={() => onChange(items.filter((_, j) => j !== i))} disabled={items.length === 1 && testId === "primary-artists"}
            className="h-9 w-9 shrink-0 grid place-items-center rounded-md text-muted-foreground hover:text-destructive disabled:opacity-30 disabled:hover:text-muted-foreground"
            data-testid={`${testId}-remove-${i}`} title={t("Quitar")}><Trash2 className="h-4 w-4" /></button>
        </div>
      ))}
      {items.length < max && (
        <button type="button" onClick={() => onChange([...items, ""])} data-testid={`${testId}-add`}
          className="text-xs text-primary hover:underline flex items-center gap-1"><Plus className="h-3 w-3" /> {t(addLabel)} <span className="text-muted-foreground">({items.length}/{max})</span></button>
      )}
    </div>
  );
};

export const artistDisplay = (primary = [], featured = []) => {
  const p = primary.map((n) => n.trim()).filter(Boolean);
  const f = featured.map((n) => n.trim()).filter(Boolean);
  return p.join(", ") + (f.length ? ` feat. ${f.join(", ")}` : "");
};
